import { render, staticRenderFns } from "./assignJudges.vue?vue&type=template&id=27d87ea5&scoped=true"
import script from "./assignJudges.vue?vue&type=script&lang=js"
export * from "./assignJudges.vue?vue&type=script&lang=js"
import style0 from "./assignJudges.vue?vue&type=style&index=0&id=27d87ea5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d87ea5",
  null
  
)

export default component.exports